import { types } from './actions';

export default function summitCheckoutAppReducer(state = {}, action) {
  switch (action.type) {
    case types.SET_DURATION:
      return {
        ...state,
        duration: action.duration
      };
    //
    // Adyen checkout block
    //
    case types.ADYEN_PRODUCT_CHECKOUT_REQUEST:
      return {
        ...state,
        checkout_submitting: true
      };
    case types.ADYEN_PRODUCT_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkout_success: true
      };
    case types.ADYEN_PRODUCT_CHECKOUT_FAILURE:
      return {
        ...state,
        checkout_submitting: false,
        checkout_error: true
      };
    case types.CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR:
      return {
        ...state,
        checkout_submitting: false,
        checkout_error: false
      };
    //
    // Promo code related
    //
    case types.CHECK_PROMO_CODE_REQUEST:
    case types.REMOVE_PROMO_CODE_REQUEST:
      return {
        ...state,
        promo_code_submitting: true
      };
    case types.CHECK_PROMO_CODE_SUCCESS:
    case types.REMOVE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        promo_code_submitting: false,
        promo_code_error: false,
        promo_code_input_visibility: false,
        products: action.payload.products,
        duration: action.payload.products.default_selected
      };
    case types.CHECK_PROMO_CODE_FAILURE:
    case types.REMOVE_PROMO_CODE_FAILURE:
      return {
        ...state,
        promo_code_submitting: false,
        promo_code_error: true
      };
    case types.TOGGLE_PROMO_CODE_INPUT_VISIBILITY:
      return {
        ...state,
        promo_code_input_visibility: !state.promo_code_input_visibility
      };
    default:
      return state;
  }
}
